import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useScroll } from "../context/ScrollContext";
import componentMap from "../untils/componentmap";
import { getPageMetaData } from "../ReduxActions/getPageDataAction";

export default function Home() {
    console.log("Home component rendered");

    const dispatch = useDispatch();
    const location = useLocation();
    const { sectionRefs, registerSection, scrollToSection } = useScroll(); // Get scroll functions
    const [pageData, setPageData] = useState(null);

    const homepageData = useSelector((state) => state.pagedata.data);

    // Fetch page data on mount
    useEffect(() => {
        console.log("Fetching page metadata...");
        dispatch(getPageMetaData("home-page"));
    }, [dispatch]);

    // Update pageData when Redux state changes
    useEffect(() => {
        console.log("Updating pageData...");
        setPageData(homepageData);
    }, [homepageData]);

    // Extract the last part of the pathname for scrolling (e.g., "/home" → "home")
    useEffect(() => {
        console.log(location.pathname); //here i see / in console
        const pathKey = location.pathname.split("/").pop();
        console.log("Detected Path:", pathKey);

        if (pathKey) {
            scrollToSection(pathKey);
        }
    }, [location, scrollToSection]);

    // Register all section keys before rendering
    useEffect(() => {
        if (pageData?.components) {
            pageData.components.forEach((comp) => registerSection(comp.key));
        }
    }, [pageData, registerSection]);

    console.log("Final Page Data:", pageData);

    return (
        <div>
            {pageData?.components
                ?.filter((comp) => comp.visible)
                ?.sort((a, b) => a.order - b.order)
                ?.map((comp) => {
                    const Component = componentMap[comp.key] || (() => <div>Unknown Component</div>);
                    return (
                        <div key={comp.key} id={comp.key} ref={sectionRefs.current[comp.key]}>
                            <Component content={comp.data} />
                        </div>
                    );
                })}
        </div>
    );
}
